/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import G17Client from '../../services/G17Client';
import { DownloadButton } from '../button/DownloadButton';


interface ActionButtonProps {
  holdingId: string;
}

export const ActionButton = ({ holdingId }: ActionButtonProps) => {

  const handleDownloadContributions = async () => G17Client.downloadPortfolioContributions(holdingId);  

  return (
    <DownloadButton
      color='link'
      size='sm'
      onClick={handleDownloadContributions}
      className='pr-0 btn__download'
      block
    >
      <i className='fas fa-file-csv mr-2 fa-lg' />
      Download SDG contributions report
    </DownloadButton>
  );
}
